import React from "react";
import technology1 from "../assets/technology1.png";
import technology2 from "../assets/technology2.png";
import technology3 from "../assets/technology3.png";
import technology4 from "../assets/technology4.png";
import technology5 from "../assets/technology5.png";
import technology6 from "../assets/technology6.png";
import technology7 from "../assets/technology7.png";
import "./Technology.css";

const technologyCards = [
  {
    id: 1,
    image: technology1,
    title: "Advanced ML Frameworks",
    description:
      "We work with modern machine learning frameworks that support deep learning, neural networks, and classical models—helping us build accurate, scalable, and production-ready solutions tailored to your business challenges.",
  },
  {
    id: 2,
    image: technology2,
    title: "Data Processing & Feature Engineering Tools",
    description:
      "Our team uses powerful data preprocessing and transformation tools to clean, enrich, and structure raw datasets. This ensures the ML models learn from meaningful patterns and deliver sharper predictions.",
  },
  {
    id: 3,
    image: technology3,
    title: "Model Training & Optimization Platforms",
    description:
      "We rely on technology that accelerates model training, hyperparameter tuning, and performance evaluation. This helps us deliver high-accuracy models faster, with consistent results across different environments."
  },
  {
    id: 4,
    image: technology4,
    title: "Cloud-Based ML Deployment Systems",
    description:
      "Our ML solutions are deployed on secure cloud platforms that support autoscaling, load balancing, and real-time performance. This ensures stable and reliable operations, even during heavy workloads."
  },
  {
    id: 5,
    image: technology5,
    title: "Workflow Automation & MLOps Pipelines",
    description:
      "We use automated pipelines for versioning, monitoring, and lifecycle management. This keeps your machine learning models updated, optimized, and fully aligned with changing business needs.",
  },
      {
    id: 6,
    image: technology6,
    title: "Real-Time API & Integration Layer",
    description:
      "Our ML models are integrated through fast, secure API layers that support real-time predictions and seamless connectivity with your existing software, dashboards, or enterprise systems.",
  },
  {
    id: 7,
    image: technology7,
    title: "Secure Data Storage & Compute Infrastructure",
    description:
      "We leverage robust computational and storage systems built to handle large datasets securely. This supports faster training, safe data handling, and consistent model performance in production."
  },
];

export default function Technology() {
  return (
    <div id="technology" className="machinemainclass">
      <div className="left">
        <h2 className="heading">
         Tools, Libraries & Frameworks Behind Our ML Expertise
        </h2>
        <p className="subheading">
         As a machine learning development company trusted by enterprises, we use a powerful mix of tools, libraries, and frameworks to build accurate, scalable, and production-ready models. Our tech stack ensures faster experimentation, smoother deployment, and consistently reliable performance in real-world environments.
        </p>
      </div>

      <div className="right">
        <div className="cards">
          {technologyCards.map((card) => (
            <div className="card" key={card.id}>
              <img src={card.image} alt={card.title} />
              <h3>{card.title}</h3>
              <p>{card.description}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
